import styled from 'styled-components';

const Wrapper = styled.main`
  nav {
    width: var(--fluid-width);
    max-width: var(--max-width);
    margin: 0 auto;
    height: var(--nav-height);
    display: flex;
    align-items: center;
  }
  .page {
    min-height: calc(100vh - var(--nav-height));
    display: grid;
    align-items: center;
    margin-top: 20px;
  }
  h1 {
    font-weight: 700;
    span {
      color: var(--primary-500);
    }
  }
  p {
    color: var(--grey-600);
  }
  .main-img {
    display: none;
  }
  @media (min-width: 992px) {
    .page {
      grid-template-columns: 1fr 1fr;
      column-gap: 3rem;
      margin-top: 0px;
    }
    .main-img {
      display: block;
      width: 75%;
      margin: auto;
      object-fit: cover;
    }
  }
  @media (max-width: 992px) {
    .info {
      text-align: center;
    }
    p {
      margin: 0 auto 1.5rem;
      max-width: 40em;
    }
  }
`;
export default Wrapper;
